import { createContext } from 'react';

export const ReportStyleContext = createContext({
    color: {},
    radius: false,
    setReportStyle: () => {},
});
